export enum PromotionRewardTypeEnum {
    Free_Product = 22,
    Free_Shipping = 57
  }


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/promotion-reward-type.enum.ts